import STEPS from './Steps';

export default STEPS;
